import React from 'react';

const About: React.FC = () => {
  const stats = [
    { number: '4+', label: 'Years Experience', icon: 'fas fa-calendar-alt' },
    { number: '40+', label: 'Daily Tickets Resolved', icon: 'fas fa-ticket-alt' },
    { number: '98%', label: 'Resolution Rate', icon: 'fas fa-check-circle' },
    { number: '1000+', label: 'Issues Resolved', icon: 'fas fa-tasks' }
  ];

  return (
    <section id="about" className="py-20 bg-slate-900/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 fade-in">
            About <span className="gradient-text">Me</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto fade-in">
            Get to know more about who I am, what I do, and what skills I have
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* About Content */}
          <div className="slide-in-left">
            <h3 className="text-2xl md:text-3xl font-bold mb-6 text-white">
              I'm Kirat Mehta, a passionate Technical Support Analyst & Programmer
            </h3>
            
            <div className="space-y-4 text-gray-300 text-base md:text-lg leading-relaxed">
              <p>
                Technical Support Analyst with <strong>4+ years of experience</strong> in troubleshooting, customer service, 
                C#, MS SQL, and Azure. Currently working at Concentrix as a Technical Support Advisor II, providing 
                expert support for a leading global tech client.
              </p>
              
              <p>
                Demonstrated expertise in <strong>REST and SOAP APIs</strong>, MS SQL, and Azure, enhancing client 
                satisfaction by efficiently resolving technical issues. Known for resolving client issues efficiently 
                while ensuring SLA compliance.
              </p>
              
              <p>
                <strong>Bilingual in English & French</strong> with strong communication skills. Passionate about 
                technology and continuous learning with advanced experience in AI tools, prompt engineering, and 
                modern development practices. When I'm not troubleshooting, you'll find me exploring new technologies 
                or helping others solve technical challenges.
              </p>
            </div>

            <div className="mt-8">
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center bg-primary hover:bg-primary/90 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-primary/50"
              >
                <i className="fas fa-user mr-2"></i>
                Let's Connect
              </a>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="slide-in-right">
            <div className="grid grid-cols-2 gap-4 md:gap-6 mb-8">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className="stat-card bg-slate-800/50 backdrop-blur-sm p-5 md:p-6 rounded-xl text-center border border-slate-700/50 hover:bg-slate-800/70 transition-all duration-300 flex flex-col items-center justify-center min-h-[140px]"
                >
                  <div className="text-primary text-3xl md:text-4xl mb-3">
                    <i className={stat.icon}></i>
                  </div>
                  <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-2">
                    {stat.number}
                  </div>
                  <div className="text-gray-400 text-xs md:text-sm font-medium">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            {/* Additional Info */}
            <div className="bg-slate-800/30 backdrop-blur-sm p-6 rounded-xl border border-slate-700/50">
              <h4 className="text-xl font-semibold text-white mb-4 flex items-center">
                <i className="fas fa-lightbulb text-primary mr-2"></i>
                What I Bring to the Table
              </h4>
              <ul className="space-y-3 text-gray-300">
                <li className="flex items-start">
                  <i className="fas fa-check-circle text-primary mr-3 mt-1 flex-shrink-0"></i>
                  <span>Strong problem-solving and analytical skills</span>
                </li>
                <li className="flex items-start">
                  <i className="fas fa-check-circle text-primary mr-3 mt-1 flex-shrink-0"></i>
                  <span>Experience with modern development practices</span>
                </li>
                <li className="flex items-start">
                  <i className="fas fa-check-circle text-primary mr-3 mt-1 flex-shrink-0"></i>
                  <span>Excellent communication and teamwork abilities</span>
                </li>
                <li className="flex items-start">
                  <i className="fas fa-check-circle text-primary mr-3 mt-1 flex-shrink-0"></i>
                  <span>Passion for continuous learning and improvement</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;